import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Box, Button, Link } from '@mui/material';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function NavBar() {
    const [anchorEl, setAnchorEl] = useState(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            padding: 0, 
            borderRadius: 0, 
            marginTop: theme.spacing(1.25) // 10px
        }}>
            <AppBar 
                position="static" 
                sx={{ 
                    borderRadius: 0, 
                    width: '100%', 
                    boxShadow: 'none',
                    backgroundColor: 'background.paper',
                    padding: 0,
                }}
            >
                <Toolbar sx={{ 
                    justifyContent: 'space-between', 
                    padding: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Link 
                            href="/" 
                            sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                textDecoration: 'none',
                                color: 'inherit',
                            }}
                        >
                            <Typography 
                                variant="h4" 
                                component="div" 
                                sx={{ 
                                    fontWeight: theme.typography.h4.fontWeight,
                                    color: 'text.primary',
                                    paddingBottom: '3px',
                                }}
                            >
                                tenderead
                            </Typography>
                        </Link>
                    </Box>
                    {isMobile ? (
                        <>
                            <IconButton 
                                edge="start" 
                                aria-label="menu" 
                                onClick={handleMenuOpen}
                                sx={{ color: 'text.primary' }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                                sx={{ 
                                    marginTop: 0, 
                                    marginLeft: theme.spacing(-3.125), // -25px
                                }}
                            >
                                <MenuItem 
                                    onClick={handleMenuClose} 
                                    component="a" 
                                    href="/dashboard"
                                >
                                    Start Using
                                </MenuItem>
                            </Menu>
                        </>
                    ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(2) }}>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="large"
                                href="/signin"
                            >
                                Login
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                href="/signin"
                                endIcon={<ArrowForwardIcon />}
                            >
                                Create Account
                            </Button>
                        </Box>
                    )}
                </Toolbar>
            </AppBar>
        </Box>
    );
}

export default NavBar;

